import {
  MediaQuestionConfig,
  MediaResponseState,
  useFindMedia,
} from '@gripp/shared-logic';
import { useState } from 'react';
import { View } from 'react-native';
import { getImageThumbnailWidth } from '../../../../../components/media/getMediaThumbnailWidth';
import { MessageMedia } from '../../../../issue/messageMedia';
import { RoutineQuestionMessage, RoutineQuestionMessageProps } from '../types';

export const MediaQuestionMessage: RoutineQuestionMessage<
  MediaQuestionConfig,
  MediaResponseState
> = (
  props: RoutineQuestionMessageProps<MediaQuestionConfig, MediaResponseState>
) => {
  const { response } = props;
  const [mediaWidth, setMediaWidth] = useState<number>();
  const media = useFindMedia({
    filter: {
      id: { in: response.mediaIds },
    },
  });

  return (
    media && (
      <View
        onLayout={(event) => {
          const { width } = event.nativeEvent.layout;
          const thumbnailWidth = getImageThumbnailWidth(width);
          setMediaWidth(thumbnailWidth);
        }}
      >
        <MessageMedia media={media} displayWidth={mediaWidth} />
      </View>
    )
  );
};
